import {
  Avatar,
  Box,
  // Button,
  Container,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  MenuItem,
  Select,
  // Stack,
  Typography,
} from "@mui/material";
//* Fecha formato
import bdService from "../../services/maestros.service";
import bdFlotamaq from "../../services/flotamaq.service";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack"; //Para alertas notificaciones
//****** iconos */
import ListAltIcon from "@mui/icons-material/ListAlt";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
// import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

import { useEffect, useRef, useState } from "react";
import NumFormato from "../../helpers/numerico";
import TextFieldCustom from "../../helpers/CustomTextFields";
const Bitacoras = () => {
  const { enqueueSnackbar } = useSnackbar();
  //********** Sucursal ******************************/
  const [sucursales, setSucursales] = useState([]);
  const [bSeleccionada, setbSeleccionada] = useState(false);
  const [NomSucursal, setNomSucursal] = useState(null);
  // const [SucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [BodegaSeleccionada, setBodegaSeleccionada] = useState("");
  const [bSeleccionDesRes, setbSeleccionDesRes] = useState(false);
  const [bSeleccionMaquina, setbSeleccionMaquina] = useState(false);
  const [DatoSeleccionado, setDatoSeleccionado] = useState([]);
  const [dTemperatura, setdTemperatura] = useState(0);
  // const [iDatoAnterior, setDatoAnterior] = useState(0);
  const [sTextObservacion, setsTextObservacion] = useState("");
  // const [isDesRes, setDesRes] = useState("");
  //**************************************** */
  /* Datos Seleccionados */
  //**************************************** */
  const [listaMaq, setlistaMaq] = useState([]);
  // eslint-disable-next-line
  const [iMostrarStk, setiMostrarStk] = useState(0);
  //**************************************** */
  // Redux
  //**************************************** */
  const { usuario } = useSelector((state) => state.user);
  //*************************************** */
  const TempRef = useRef(null);
  const ObsRef = useRef(null);
  // ********************************************************** */
  // ****************** Llenado Sucursal ********************** */
  // ********************************************************** */
  const Limpiar = () => {
    //********** Sucursal ******************************/
    setbSeleccionada(false);
    setNomSucursal("");
    // setSucursalSeleccionada(null);
    setBodegaSeleccionada("");
    setbSeleccionDesRes(false);
    setbSeleccionMaquina(false);
    // setDesRes("");
    setiMostrarStk(0);

    setDatoSeleccionado([]);
    setdTemperatura(0);
    // setDatoAnterior(0);
    setsTextObservacion("");
  };

  const CargarSucursales = async () => {
    try {
      const iSucursal =
        parseInt(usuario.TipoUsuario) <= 1 ? -1 : usuario.Sucursal;
      const datos = await bdService.Sucursales(iSucursal, "A");
      if (datos.status === 200) {
        // Llenado
        setSucursales(datos.data.Sucursales);
        if (parseInt(usuario.TipoUsuario) <= 1) {
          //******** Seleccionar una sucursal */
          setbSeleccionada(false);
        } else {
          if (datos.data.Sucursales.length === 1) {
            //******** Asignando datos de la bodega automaticamente */
            setNomSucursal(datos.data.Sucursales[0].Nombre);
            // setSucursalSeleccionada(datos.data.Sucursales[0].Sucursal);
            // setBodegaSeleccionada(datos.data.Sucursales[0].Bodega);
            setbSeleccionada(true);
            setbSeleccionDesRes(true);
            ListaMaquinarias(datos.data.Sucursales[0].Sucursal);
          } else {
            //******** Seleccionar una sucursal */
            setbSeleccionada(false);
          }
        }
      } else if (datos.status === 400) {
        // Esta mal
      }
    } catch (error) {
      // Manejo del error si ocurre
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    Limpiar();
    CargarSucursales();
  }, []);

  //********************* Combo sucursal */
  const handleChangeComboBox = async (event) => {
    const nombreSeleccionado = event.target.value;
    const SucBodSelect = sucursales.find(
      (sucursal) => sucursal.Nombre === nombreSeleccionado
    );
    // setSucursalSeleccionada(SucBodSelect.Sucursal);
    // setBodegaSeleccionada(SucBodSelect.Bodega);
    setNomSucursal(nombreSeleccionado);
    setbSeleccionada(true); //cambia a seleccionada a true para continuar
    setbSeleccionDesRes(true); // Para que aparezca los botones de Despacho y Reserva
    ListaMaquinarias(SucBodSelect.Sucursal);
    // Buscar datos detalle
  };

  //*********************************************************** */
  //**************** Consultando al CodigoBarra */
  // llamado para listado de flota maquinas
  // CALL up_obt_flotamaq('*', '*', -1, 'A');
  //*********************************************************** */
  const ListaMaquinarias = async (Sucursal) => {
    try {
      let response;
      response = await bdFlotamaq.dsflotamaq("*", "F", Sucursal, "A");

      if (response.status === 200) {
        setlistaMaq(response.data.flotamaq);
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };

  const onClickLista = async (valor) => {
    setbSeleccionMaquina(true);
    setbSeleccionDesRes(false);
    setDatoSeleccionado(valor);
    setTimeout(() => {
      TempRef.current.focus();
    }, 300);
  };

  const onClickVolver = () => {
    setbSeleccionDesRes(true);
    setbSeleccionDesRes(false);
    Limpiar();
  };

  const handle_GotFocus_dTemperatura = (value) => {
    // setDatoAnterior(value.target.value); // Colocando el valor anterior 1.000,6 a 1000,6
    setdTemperatura(value.target.value); // formateando el numero para digitar  1.000,6 a 1000.6
  };

  const handle_Change_dTemperatura = (value) => {
    if (value === "") {
      setdTemperatura("");
    } else {
      setdTemperatura(value);
    }
  };

  const handle_KeyDown_dTemperatura = (event) => {
    if (event.key === "Enter") {
      setTimeout(() => {
        ObsRef.current.focus();
      }, 200);
    }
  };
  const handle_LostFocus_dTemperatura = (value) => {
    setdTemperatura(
      NumFormato.NumeroFormateado(value.target.value, false, true, 1)
    );
  };

  const handle_GotFocus_Observacion = (value) => {
    //setDatoAnterior(value.target.value); // Colocando el valor anterior 1.000,6 a 1000,6
    setsTextObservacion(value.target.value); // formateando el numero para digitar  1.000,6 a 1000.6
  };

  const handle_Change_Observacion = (value) => {
    if (value === "") {
      setsTextObservacion("");
    } else {
      setsTextObservacion(value);
    }
  };

  const handle_KeyDown_Observacion = (event) => {
    if (event.key === "Enter") {
      // setTimeout(() => {
      //   // ScanBarraRef.current.focus();
      // }, 200);
    }
  };
  const handle_LostFocus_Observacion = (value) => {
    // console.log(value);
    // setdTemperatura(
    //   NumFormato.NumeroFormateado(value.target.value, false, true, 1)
    // );
  };

  const onClickActualizar = async () => {
    try {
      const _PlacaSerie = DatoSeleccionado.PlacaSerie;
      const _FecInicio = "*"; //"'" & Format(_FecInicio, "ddMMyyyyHHmm") & "', " &
      const _kmsInicio = 0;
      const _FecTermino = "*"; //"'" & Format(_FecTermino, "ddMMyyyyHHmm") & "', " &
      const _KmsTermino = 0;
      const _CargaComLts = -1;
      const _CargaComKms = -1;
      const _Temperatura = NumFormato.ConvertirNumero(dTemperatura.toString());
      const _Observacion = sTextObservacion.toString(); ///
      const _Estado = "C";
      const _IdChofer = 0;
      const _IdDigitador = usuario.Id;
      const _UsoAco = ""; //"'" & IIf(_UsoAco = "X", "X", "") & "', " &
      const _UsoEnt = ""; //"'" & IIf(_UsoEnt = "X", "X", "") & "', " &
      const _UsoVar = ""; //"'" & IIf(_UsoVar = "X", "X", "") & "', " &
      const _Costo = 0;
      const _Venta = 0;
      const _IdCostoVenta = -1;

      const response = await bdFlotamaq.put_bitacora(
        "I",
        _PlacaSerie,
        _FecInicio,
        _kmsInicio,
        _FecTermino,
        _KmsTermino,
        _CargaComLts,
        _CargaComKms,
        _Temperatura,
        _Observacion,
        _Estado,
        _IdChofer,
        _IdDigitador,
        _UsoAco,
        _UsoEnt,
        _UsoVar,
        _Costo,
        _Venta,
        _IdCostoVenta
      );
      //*********************************************************** */
      if (response.status === 200) {
        enqueueSnackbar(`¡¡¡Registro actualizado!!!`, {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        //*** Reinicia para otro código */
        Limpiar();
        //***
      } else {
        enqueueSnackbar(`Error en grabación ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
      console.log("Error ", error);
    }
  };

  //*********************************************************** */
  return (
    <div>
      <Container maxWidth="sm">
        <Container maxWidth="sm" sx={{ mt: 1 }}></Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Box
              borderRadius="8px"
              sx={{ boxShadow: 1, backgroundColor: "#FFFFFF", height: "auto" }}
            >
              {!bSeleccionada ? (
                <Grid container spacing={1} sx={{ p: 1 }}>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                      Bitacoras
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Select
                      value={BodegaSeleccionada} // we want to work in controlled mode
                      displayEmpty
                      fullWidth
                      onChange={handleChangeComboBox} // we want to work in controlled mode
                    >
                      <MenuItem value="" disabled>
                        Sucursales
                      </MenuItem>
                      {sucursales?.map((option) => {
                        return (
                          <MenuItem key={option.Nombre} value={option.Nombre}>
                            {option.Nombre ?? option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={1} sx={{ p: 1 }}>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                      Bitacoras {NomSucursal}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
        {bSeleccionada && bSeleccionDesRes && (
          <>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius={"8px"}
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    color: "text.secondary",
                    p: 1,
                    maxWidth: "100%",
                    textAlign: "right",
                  }}
                >
                  <IconButton onClick={onClickVolver}>
                    <Avatar sx={{ backgroundColor: "green" }}>
                      <ListAltIcon />
                    </Avatar>
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <List aria-label="contacts">
                    {Array.isArray(listaMaq) && listaMaq.length > 0 ? (
                      listaMaq.map((item, index) => (
                        <ListItem key={item.PlacaSerie}>
                          <ListItemButton
                            sx={{
                              width: "100%",
                              backgroundColor:
                                index % 2 === 0 ? "#F4F6F6 " : "#F2F4F4",
                            }}
                            onClick={() => onClickLista(item)}
                          >
                            {/* Agrega aquí tu ícono */}
                            <ListItemText
                              // primary={`Nº:${item.PlacaSerie} / : ${item.NomTipo} `}
                              primary={
                                <Box>
                                  <Typography variant="body1">{`Nº: ${item.PlacaSerie}`}</Typography>
                                  <Typography variant="body2">{`Tipo: ${item.NomTipo}`}</Typography>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >{`Marca: ${item.Marca}`}</Typography>
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >{`Modelo: ${item.Modelo}`}</Typography>
                                </Box>
                              }
                              // secondary={`Marca: ${item.Marca}`}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))
                    ) : (
                      <Box
                        sx={{
                          textAlign: "center",
                          padding: "16px",
                          color: "text.secondary",
                        }}
                      >
                        No hay datos disponibles.
                      </Box>
                    )}
                  </List>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
        {bSeleccionMaquina && (
          <>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius={"8px"}
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    color: "text.secondary",
                    p: 1,
                    maxWidth: "100%",
                    textAlign: "right",
                  }}
                >
                  <IconButton onClick={onClickVolver}>
                    <Avatar sx={{ backgroundColor: "green" }}>
                      <ListAltIcon />
                    </Avatar>
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Grid container sx={{ p: 1 }} spacing={1}>
              <Grid item xs={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <TextFieldCustom
                    id="full"
                    label={`Temperatura`}
                    value={dTemperatura}
                    TamanioFuente={"14px"}
                    labelStyle={{
                      color: "blue",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                    fullWidth
                    inputMode="numeric"
                    inputRef={TempRef}
                    maxLength={11}
                    isNumeric={true} // si es numerico
                    decimal={true} // Indica si es decimal
                    Negativo={true}
                    decimalCantidad={1} //numero de decima
                    onFocus={handle_GotFocus_dTemperatura} //focus
                    onChange={handle_Change_dTemperatura} //change
                    onBlur={handle_LostFocus_dTemperatura} //al salir foco
                    onKeyDown={handle_KeyDown_dTemperatura} // al soltar un boton
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <TextFieldCustom
                    id="full"
                    label={`Observación`}
                    value={sTextObservacion}
                    TamanioFuente={"14px"}
                    inputRef={ObsRef}
                    labelStyle={{
                      color: "blue",
                      fontSize: "15px",
                      textAlign: "center",
                    }}
                    Alineacion="left"
                    multiline
                    maxRows={4}
                    fullWidth
                    isNumeric={false}
                    inputMode="text"
                    onFocus={handle_GotFocus_Observacion} //focus
                    onChange={handle_Change_Observacion} //change
                    onBlur={handle_LostFocus_Observacion} //al salir foco
                    onKeyDown={handle_KeyDown_Observacion} // al soltar un boton
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconButton onClick={onClickActualizar}>
                    <Avatar sx={{ backgroundColor: "green" }}>
                      <CheckCircleRoundedIcon />
                    </Avatar>
                  </IconButton>
                  {/* <IconButton onClick={onClickCancelar}>
                    <Avatar sx={{ backgroundColor: "red" }}>
                      <CancelRoundedIcon />
                    </Avatar>
                  </IconButton> */}
                </Box>
              </Grid>
            </Grid>
          </>
        )}
      </Container>
    </div>
  );
};
export default Bitacoras;
